"use strict";

// TODO: re-enable english labels on english pages
// viewBox is required to resize contents with SVG size
function setIcons(base) {

	const icons = {
		fullArrow: "<svg viewBox='0 0 24 24' class='icon widget-ornament' aria-hidden='true'><path d='M1 12h22m-11-11l11 11l-11 11'></path></svg>",
		headArrow: "<svg viewBox='0 0 24 24' class='icon widget-ornament' aria-hidden='true'><path d='m8 4 8 8-8 8'></path></svg>",
		external: "<svg viewBox='0 0 24 24' class='icon widget-ornament external' aria-label='Åpnes i nytt vindu'><path d='M8 6 h-3 a3 3 0 0 0 -3 3 v9 a3 3 0 0 0 3 3 h9 a3 3 0 0 0 3 -3 v-3'></path><path class='arrow' d='M19 12v-8 h-8 m8 0 l -12 12'></path></svg>",
		download: "<svg viewBox='0 0 24 24' class='icon widget-ornament download' aria-label='Nedlasting'><path d='M1.5 17.5v2a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-2'></path><path class='arrow' d='M12.5 1.5v12m-5-5l5 5 5-5'></path></svg>",
	};

	// NB: don't put SVG code for these in Icons component! this JS file is cached, the Icons component gets downloaded with every pageview

	/* don't run DOM editing code in editing mode, or else the modified elements will be stored */
	/* (or just for speeding up the editing interface where we don't need lots of the interactivity) */
	/* Note: if many pages need cleaning up, it can be a solution to put in a script that is loaded in edit mode (eg link target, nbsp, empty tags) */
	if (!(document.querySelector("body").classList.contains("isEditing"))) {

		// TODO: can we use a generic SVG with empty path, and set the path parameters in CSS? <svg><path style='d:path("10h10v-10h-10v")'/></svg>
		// - Not supported by Safari yet, https://developer.mozilla.org/en-US/docs/Web/CSS/Reference/Properties/d
		// Alternative using CSS only: background-image, clip-path or mask
		// for:
		// - does not require JS
		// - much easier to assign different icons on specific pages (don't need to remove default icon before placing a new)
		// - allows for different icons per theme
		// - allows for new elements to be created after page load, without manually triggering icons script
		// - MDN, designsystemet.no uses masks
		// against:
		// - requires either ::before or ::after pseudo-element, can conflict with other styling
		//   - could be resolved by having a dedicated <tag class='icon'> tag everywhere, but that again requires either JS or server-side modifications
		//   - this icon element could have ::before or ::after for more complex animations
		//   - <i> means "idiomatic", could be considered semantic for icons (esp with visually hidden text)
		//   - <span> with aria-label requires role=img
		//   - <img> requires src (could be a minimal data-uri)
		//   - <svg> safari doesn't support changing shape through css, have to use background/mask/clip-path, not semantic
		// - requires both ::before and ::after for 2-part icons (external link, download)
		//   - squash in one icon (https://lottiefiles.com/free-animation/external-link-iTCy2lF4nB, https://www.flaticon.com/free-animated-icon/download_7741071)
		//   - or use different icon on hover, but that doesn't allow for animation
		//   - clip-path can be animated, but must stay within container
		// - not possible to attach aria-attributes
		//   - MDN uses CSS content property (.external:after { content: "\200b"/" (external)" })
		//   - can add .sr-only text to links, but that requires JS again
		//   - or icon tag with text content, and use css image replacement (impr nir)
		// - can't centrally control stroke-width etc
		// - can't assign a class to the icon, must be to parent element (eg, .hasicon)
		// - use background-color for what really is element color
		// - clip-path: only respects fill, not stroke
		// - background-image: requires a new image for *every* color (not just light/dark, but every color in use), can not use var() for color

		// BUG: don't use inner/outerHTML, as this can conflict with other async DOM editing methods! use insertAdjacentHTML instead
		// TODO: wrapper for all icons, allows more flexibility

		let elms, e;

		// infobox icons
		// info icon
		elms = base.querySelectorAll(".informationboxwrapper.info, .hb-layout.info > :first-child");
		// needs better identifier; .informationboxwrapper is used by various boxes
		// using modern :is causes JS to break on older browsers
		// .hb-layout has flex layout, AND child width is based on nr of children, so icon has to go inside child
		for (e of elms)
			e.innerHTML = 
				"<svg class='icon widget-ornament box-icon' viewBox='0 0 24 24'>" +
					"<title>Info</title>" +
					"<g fill='currentColor' stroke='none'>" +
						"<path d='M11.7 17a7.4 7.4 0 0 0 2-2.1l-.2-.3c-.7.7-2 1.6-1.8 1l1.7-5.4-3.3.4v.3c.7 0 1 .3 1 .6l-1.3 4-.1.9c0 .7 1 1.1 2 .6z'/>" +
						"<circle cx='12.8' cy='7.9' r='1.1'/>" +
						"<circle cx='12' cy='12' r='9.2' fill='none' stroke='currentColor'/>" +
					"</g>" +
				"</svg>" +
				"<div>" + e.innerHTML + "</div>"; // old contents must go in new container, as the parent needs to get flex layout (see infobox loanselector)
		// warning icon
		elms = base.querySelectorAll(".informationboxwrapper.warning, .hb-layout.warning > :first-child");
		// .hb-layout has flex layout, AND child width is based on nr of children, so icon has to go inside child
		for (e of elms)
			e.innerHTML = 
				"<svg class='icon widget-ornament box-icon' viewBox='0 0 24 24'>" +
					"<title>" + (e.closest("[lang]").lang == "en" ? "Note" : "Obs") + "</title>" +
					"<g fill='currentColor' stroke='none'>" +
						"<path d='M13.2 7.7c0 .5-.2 4.1-.6 5.8-.1.4-.1.7-.6.7-.4 0-.5-.3-.6-.7a31 31 0 0 1-.6-5.8c0-.6.6-1.2 1.2-1.2s1.2.6 1.2 1.2z'/>" +
						"<circle cx='12' cy='16.7' r='1.2'/>" +
						"<circle cx='12' cy='12' r='9.2' fill='none' stroke='currentColor'/>" +
					"</g>" +
				"</svg>" +
				"<div>" + e.innerHTML + "</div>";

		const downloadexts = [".pdf",".doc",".xls",".ppt"];
		// negative approach: "a[href]:not(:is([href=''],[href^='java'],[href$='/'],[href*='/?'],[href*='.htm'],[href*='.aspx']))"
		// but how to detect this? https://kommunikasjon.ntb.no/pressemelding/18166403/31-prosjekt-far-bustadsosialt-tilskot?publisherId=2823375&lang=no

		const isExternalLink = e => 
			e instanceof HTMLAnchorElement &&
			e.getAttribute("href").includes("http"); /* substring search faster than creating new URL object? */
		const isDownloadLink = e =>
			e instanceof HTMLAnchorElement &&
			downloadexts.some(ext => e.getAttribute("href").includes(ext));

		// note: don't check for empty links (href=''), this is too rare on live site
		// consider: english/norwegian flag icon for links that switch language

		// external links
		// remove all targets, there are still a few manually assigned
		// there are currently no more wrong targets, but do check if this problem resurfaces
		// base.querySelectorAll("a[target]").forEach(elm => {
		// 	elm.removeAttribute("target");
		// });

		// Add target to all external links
		// skip links already decorated server-side
		// BUG: should go for all file types, not only pdf. look through all anchors and do check in JS instead
		base.querySelectorAll("a:is([href^='http'],[href*='.pdf']):not([data-rte-decorated])").forEach(elm => {
			// just treat all http-links as external, helps detecting full url internal links
			elm.setAttribute("target","_blank");
			elm.setAttribute("rel","noopener noreferrer"); // prevent external sites from accessing our page content
		});

		// surfaces: icon first, to wrap text
		// TODO: use .title class
		// BUG: data-rte-decorated is only applied to links with target, not to links that have icon added
		base.querySelectorAll(".surface a:not(:is(.richtext a))").forEach(elm => {
			if (isDownloadLink(elm))
				elm.insertAdjacentHTML("afterbegin",icons.download);
			else if (isExternalLink(elm))
				elm.insertAdjacentHTML("afterbegin",icons.external);
			else
				elm.insertAdjacentHTML("afterbegin",icons.fullArrow);
		});

		// linkbuttons: icon last
		// NB: some linkbuttons already have an icon, eg login button in header
		// :is(a.button,.linkButton):not(:has(svg)), .informationboxcontent > a:only-child
		// BUG: data-rte-decorated is only applied to links with target, not to links that have icon added
		([
			...Array.from(base.querySelectorAll("a.button, .linkButton")).filter(el => !el.querySelector(".icon")),
			...Array.from(base.querySelectorAll(".informationboxcontent > a:only-child"))
		]).forEach(elm => {
			if (isDownloadLink(elm))
				elm.insertAdjacentHTML("beforeend",icons.download);
			else if (isExternalLink(elm))
				elm.insertAdjacentHTML("beforeend",icons.external);
			else
				elm.insertAdjacentHTML("beforeend",icons.headArrow);
		});

		// common download links
		// consider: own icons for each filetype
		// a:not(:has(svg)):is([href*='.pdf'],[href*='.doc'],[href*='.xls'],[href*='.ppt'])
		// TODO: more and more filetypes can be opened in browser (pdf, jpg), so maybe mark all as "opens in new window" instead?
		// - then we can also have icon based on [target] instead of difficult CSS queries
		([...base.querySelectorAll("a[href*='.pdf'],a[href*='.doc'],a[href*='.xls'],a[href*='.ppt']")].filter(el => !el.querySelector(".icon"))).forEach(elm => {
			// can be two paths in one svg, as the arrow moves down without the icon
			elm.insertAdjacentHTML("beforeend",icons.download);
		});

		// common external links
		// a:not(:has(svg))[href^='http']
		([...base.querySelectorAll("a[href^='http']")].filter(el => !el.querySelector(".icon"))).forEach(elm => {
			// has to be 2 svgs inside an html element, as the arrow moves outside the 18x18 viewBox
			// enlarging the viewBox would require changing a lot of code for other icons
			elm.insertAdjacentHTML("beforeend",icons.external);
		});
		// TODO: email links (mailto)

	}

};
setIcons(document);
